<div class="container-fluid">
  <div mat-dialog-title class="d-flex p-3 gap-3 justify-content-end actions-dialog-zoom">
    <button class="mat-raised-button"(click)="downloadImagem()"><img src="/assets/icons/download-image.svg" alt="baixar imagem"></button>
    <button class="mat-raised-button"(click)="close()"><img src="/assets/icons/download-image-x.svg" alt="fechar"></button>
  </div>
  <div class="area-image-product-detail">
    <div>
      <img src="{{url}}" alt="">
    </div>
  </div>
</div>
